export default {
    computed:{
        interval: {
            get(){
                return this.$store.getters.getSearchInterval
            },
            set(value){
                return this.$store.commit('setSearchInterval', value)
            }
        },
        updateProjectViewer: {
            get(){
                return this.$store.getters.getUpdateProjectViewer
            },
        },
        start: {
            get(){
              return this.$store.getters.getStartDate
            },
            set(value){
              return this.$store.commit('setStartDate', value)
            }
          },
          rangeDates: {
              get(){
                  return this.$store.getters.getRange
              },
              set(value){
              return this.$store.commit('setRange', value)
            }
          }
    },
    watch:{
        start: function(newVal, oldVal) { // watch it
            this.startDate = newVal
            if(newVal != oldVal){
                this.page = 1
                this.onRefresh()
                this.footerKey++
            }
        },
        rangeDates: function(newVal, oldVal) { // watch it
            this.range = newVal
            if(newVal != oldVal){
                this.page = 1
                this.onRefresh()
                this.footerKey++
            }
        },
        updateProjectViewer: function(){
            this.setRequestInterval()
        }
    },
    methods:{
    
    },
    mounted(){
        this.page = 1
        this.footerKey++
    }
  };